function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".empty-space-description" + shadowSelector + " {font-size: 14px;line-height: 20px;max-width: 280px;}.empty-space-container" + shadowSelector + " {border: 1px solid #c9c9c9;border-radius: 0.5rem;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];